export const EMAIL_KEYWORD_GROUPS = {
	Customer: [
		"${name}",
		"${customerName}",
		"${email}",
		"${customerEmail}",
		"${customerPhone}",
		"${customerPhonePrefix}",
		"${customerFullPhone}",
	],
	Booking: [
		"${formId}",
		"${orderId}",
		"${transactionId}",
		"${quantity}",
		"${total}",
		"${timeIn}",
		"${timeOut}",
		"${formattedTimeIn}",
		"${formattedTimeOut}",
		"${verificationPin}",
	],
	Station: [
		"${partnerAddress}",
		"${mapLink}",
		"${stationBookingLink}",
		"${partnerImages}",
		"${addressText}",
		"${displayName}",
		"${stationName}",
		"${ownerName}",
		"${businessName}",
		"${businessType}",
		"${ownerPhone}",
		"${password}",
		"${verificationMethod}",
		"${loginUrl}",
		"${reviewUrl}",
		"${stationOpenTime}",
		"${stationCloseTime}",
	],
	Hotline: [
		"${partnerHotlineNumber}",
		"${facilityHotline1}",
		"${facilityHotline2}",
	],
	Payment: [
		"${requestTimeUtc}",
		"${requestDateUtc}",
		"${requestAmount}",
		"${currencyCode}",
		"${paymentDate}",
		"${requestCount}",
		"${fromDate}",
		"${toDate}",
		"${totalAmount}",
		"${payoutWindow}",
		"${payFromDate}",
		"${payToDate}",
		"${payFromDateLong}",
		"${payToDateLong}",
		"${nextSettlementEmailDate}",
		"${nextSettlementEmailDateLong}",
		"${payoutPeriodLabel}",
		"${approvedAmount}",
		"${requestDates}",
		"${requestDateLabel}",
		"${requestDate}",
		"${payoutAccount}",
		"${payoutPeriod}",
		"${rejectReason}",
	],
} as const;

export const EMAIL_KEYWORD_GROUP_ORDER = ["Customer", "Booking", "Station", "Hotline", "Payment", "Other"] as const;

export const EMAIL_KEYWORD_SORT_ORDER: Record<string, Record<string, number>> = {
	Customer: {
		"${name}": 0,
		"${customerName}": 1,
		"${email}": 2,
		"${customerEmail}": 3,
		"${customerPhone}": 4,
		"${customerPhonePrefix}": 5,
		"${customerFullPhone}": 6,
	},
	Station: {
		"${displayName}": 0,
		"${stationName}": 1,
		"${ownerName}": 2,
		"${businessName}": 3,
		"${businessType}": 4,
		"${ownerPhone}": 5,
		"${password}": 6,
		"${verificationMethod}": 7,
		"${loginUrl}": 8,
		"${reviewUrl}": 9,
		"${stationOpenTime}": 10,
		"${stationCloseTime}": 11,
		"${partnerAddress}": 12,
		"${mapLink}": 13,
		"${partnerImages}": 14,
		"${addressText}": 15,
		"${stationBookingLink}": 16,
	},
	Hotline: {
		"${partnerHotlineNumber}": 0,
		"${facilityHotline1}": 1,
		"${facilityHotline2}": 2,
	},
};

export const EMAIL_KEYWORD_DESCRIPTION_OVERRIDES: Record<string, string> = {
	"${name}": "Tên khách hàng cơ bản dùng ở các template cũ.",
	"${customerName}": "Tên khách hàng hiển thị trong email booking mới.",
	"${email}": "Email khách hàng theo bộ keyword cũ.",
	"${customerEmail}": "Email khách hàng cho template booking mới.",
	"${customerPhone}": "Số điện thoại khách, chưa gồm mã quốc gia.",
	"${customerPhonePrefix}": "Mã quốc gia hoặc đầu số như +84.",
	"${customerFullPhone}": "Số điện thoại đầy đủ, đã ghép mã quốc gia.",
	"${orderId}": "Mã booking hoặc mã đơn để tra cứu.",
	"${formId}": "Mã station request hoặc mã hồ sơ station cần review.",
	"${transactionId}": "Khối Transaction ID, chỉ hiện khi có mã thanh toán.",
	"${quantity}": "Số lượng hành lý trong booking.",
	"${total}": "Tổng tiền booking theo định dạng email.",
	"${timeIn}": "Ngày drop-off ở định dạng cơ bản.",
	"${timeOut}": "Ngày pick-up ở định dạng cơ bản.",
	"${formattedTimeIn}": "Ngày giờ drop-off đã format cho người nhận.",
	"${formattedTimeOut}": "Ngày giờ pick-up đã format cho người nhận.",
	"${verificationPin}":
		"Mã PIN 4 số (có số 0 đầu) gửi khách sau thanh toán để station xác minh khi đến. Chỉ có giá trị khi bật tính năng trong Cấu hình hệ thống; nếu tắt sẽ rỗng. Để PIN nổi bật và căn giữa: dùng template [[WL-EMAIL]] với [HeaderMiddle], ví dụ Title: ${verificationPin}; chỉnh cỡ chữ thêm TitleSize: 28 và SubtitleSize: 12 (số px từ 8–96) trong cùng vùng header.",
	"${displayName}": "Tên station để hiển thị với khách.",
	"${stationName}": "Tên pháp lý hoặc tên nội bộ của station.",
	"${ownerName}": "Tên người đại diện hoặc chủ station trong hồ sơ đăng ký.",
	"${businessName}": "Tên doanh nghiệp hoặc tên station dùng trong hồ sơ station.",
	"${businessType}": "Loại hình kinh doanh mà station đã đăng ký.",
	"${ownerPhone}": "Số điện thoại của người đại diện trong hồ sơ station request.",
	"${password}": "Mật khẩu initial login đã nhập ở bước create account của station request.",
	"${verificationMethod}": "Phương thức xác minh hoặc onboarding của hồ sơ station.",
	"${loginUrl}": "Link đăng nhập dashboard station, hiện dùng https://stations.whalelo.net.",
	"${reviewUrl}": "Link mở thẳng màn station requests trong admin.",
	"${partnerAddress}":
		"Address gốc của station. Có thể là địa chỉ text bình thường hoặc chính URL Google Maps nếu station đang lưu address dưới dạng link.",
	"${mapLink}":
		"Link Google Maps dùng cho nút 'Open in Google Maps'. Nếu address là URL maps như https://maps.app.goo.gl/... thì sẽ ưu tiên dùng đúng link đó; nếu không sẽ fallback từ tọa độ hoặc địa chỉ.",
	"${stationBookingLink}":
		"Link về trang trạm cho nút 'Book again here' (/station/{destinationId}/{partnerId}, dùng mã số). Tự bỏ nút nếu thiếu mã điểm đến/đối tác — không bao giờ ra link hỏng.",
	"${partnerImages}": "Khối hình ảnh station đã render sẵn để chèn email.",
	"${addressText}":
		"Phần mô tả chi tiết bổ sung cho address, ví dụ tầng, quầy lễ tân, cổng vào hoặc landmark gần đó.",
	"${partnerHotlineNumber}": "Toàn bộ hotline station, ngắt dòng sẵn để chèn email.",
	"${facilityHotline1}": "Số hotline station thứ nhất.",
	"${facilityHotline2}": "Số hotline station thứ hai.",
	"${stationOpenTime}": "Giờ mở cửa của station.",
	"${stationCloseTime}": "Giờ đóng cửa của station.",
	"${requestTimeUtc}": "Giờ yêu cầu thanh toán theo UTC.",
	"${requestDateUtc}": "Ngày yêu cầu thanh toán theo UTC.",
	"${requestAmount}": "Số tiền của một yêu cầu thanh toán.",
	"${currencyCode}": "Mã tiền tệ như USD hoặc VNĐ.",
	"${paymentDate}": "Ngày dự kiến chốt hoặc thanh toán.",
	"${requestCount}": "Tổng số request trong kỳ thanh toán.",
	"${fromDate}": "Ngày bắt đầu kỳ tính toán.",
	"${toDate}": "Ngày kết thúc kỳ tính toán.",
	"${totalAmount}": "Tổng số tiền phải trả của cả kỳ.",
	"${reason}": "Lý do từ chối hoặc ghi chú review cho station request.",
	"${payoutWindow}":
		"Cửa sổ thanh toán dự kiến (dạng: April 1, 2026 – April 5, 2026), tính theo lịch VN trong paymentScheduleHelper.",
	"${payFromDate}": "Ngày bắt đầu cửa sổ chi trả (ISO YYYY-MM-DD).",
	"${payToDate}": "Ngày kết thúc cửa sổ chi trả (ISO YYYY-MM-DD).",
	"${payFromDateLong}": "Ngày bắt đầu cửa sổ chi trả (định dạng dài, tiếng Anh).",
	"${payToDateLong}": "Ngày kết thúc cửa sổ chi trả (định dạng dài, tiếng Anh).",
	"${nextSettlementEmailDate}": "Ngày email tổng hợp kỳ (ISO), ví dụ ngày 16 hoặc ngày 1 tháng sau tùy kỳ.",
	"${nextSettlementEmailDateLong}": "Ngày email tổng hợp kỳ (bản đọc được).",
	"${payoutPeriodLabel}": "Nhãn mô tả station gửi request thuộc kỳ 1–15 hay 16–cuối tháng (VN).",
	"${approvedAmount}": "Tổng tiền được duyệt (email duyệt rút tiền).",
	"${requestDates}": "Ngày gửi yêu cầu, dạng 1 Nov 2026 (nhiều ngày cách nhau dấu phẩy).",
	"${requestDateLabel}": "Request date / Request dates — tự đổi số ít/số nhiều.",
	"${requestDate}": "Ngày gửi yêu cầu bị từ chối, dạng 1 Nov 2026.",
	"${payoutAccount}": "Tài khoản nhận tiền, chỉ 4 số cuối (BIDV ••••7559).",
	"${payoutPeriod}": "Kỳ trả dự kiến, dạng 1–5 Dec 2026.",
	"${rejectReason}": "Lý do Admin từ chối yêu cầu rút tiền.",
};

export const EMAIL_KEYWORD_UI_COPY = {
	sectionTitle: "Danh sách từ khóa",
	countText: (filteredCount: number, totalCount: number) => `${filteredCount}/${totalCount} từ khóa`,
	searchPlaceholder: "Tìm theo tên hoặc mô tả...",
	collapseText: "Thu gọn",
	expandText: "Mở danh sách",
	noDescription: "Không có mô tả",
	emptyState: "Không tìm thấy từ khóa phù hợp với bộ lọc hiện tại.",
} as const;
